module.exports = __webpack_public_path__ + "static/media/video-17-ru.dd637527.webm";